import { render, staticRenderFns } from "./credit_quota.vue?vue&type=template&id=f7548902"
import script from "./credit_quota.vue?vue&type=script&lang=js"
export * from "./credit_quota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports